angular.module('ikeweb.user').factory('userTopics',

    function() {

        return {
            PREFERENCES: {
                UPDATED: {
                    name: 'preferences.updated'
                }
            },
            CREDITCARD: {
                UPDATED: {
                    name: 'creditcard.updated'
                }
            }
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/user.topics.js
// module id = 509
// module chunks = 0